export default __webpack_public_path__ + "static/media/conexito.12947de5.png";